<template>
	<swiper :options="parkStyleSwiperOption" ref="parkStyleSwiper">
	  <swiper-slide v-for="(item,index)  in parkStyleSwiperList" :key="item.id" class="park_swiper">
	    <div class="park_swiper_img" v-bind:style="{'backgroundImage': 'url('+item.url+')',backgroundRepeat:'no-repeat', backgroundPosition:'center center', backgroundSize: 'cover' }">
	    </div>
	    <!--<img :src="item.url" alt="">-->
	  </swiper-slide>
	  <div class="swiper-button-prev" slot="button-prev"></div>
	  <div class="swiper-button-next" slot="button-next"></div>
	</swiper>
</template>
<script>
import {swiper, swiperSlide} from 'vue-awesome-swiper';
export default {
  components: {
    swiper,
    swiperSlide
  },
  props:{
  	parkStyleSwiperList:Array
  },
  data(){
  	return {
  		parkStyleSwiperOption: {
        slidesPerView: 4,
        //paginationClickable: true,
        spaceBetween: 30,
        mousewheelControl: false,
        prevButton: '.swiper-button-prev',
        nextButton: '.swiper-button-next',
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: false,
      },
  	}
  }
}

</script>
<style lang="scss" scoped>
.park_swiper {
  min-width: 278px;
  overflow: hidden;
  .park_swiper_img {
    width: 278px;
    height: 250px;
    cursor: pointer;
    transition: transform ease 0.6s;
  }
  .park_swiper_img:hover {
    will-change: transform;
    transform: scale(1.2);
  }
}
</style>